import { render, staticRenderFns } from "./CounterNcm.vue?vue&type=template&id=4ba5e24d&"
import script from "./CounterNcm.vue?vue&type=script&lang=js&"
export * from "./CounterNcm.vue?vue&type=script&lang=js&"
import style0 from "./CounterNcm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports